import React, { Component } from 'react'
import CompanyDetailsEditForm from "./companyDetailsEditForm.component.jsx"
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage } from 'react-intl'
import SideBar from '../../common/layout/sidebar.component.jsx'

class CompanyDetailsEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            form: '',
            companyDescription: undefined,
            companyName: undefined,
            companyCity: undefined,
            companyCountry: undefined,
            companyPostalCode: undefined,
            companyState: undefined,
            companyStateCode: undefined,
            companyStreet: undefined,
            companyPhoneNumber: undefined,
            companyEmail: undefined,
            companyDescriptionId: undefined
        };
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        AppContext.getApiClient().get('/accounts/company-descriptions').then((result) => {
            var phoneNumbers = result.attributes.organization.attributes.phoneNumbers
            var phoneNumber = ''
            if (phoneNumbers.length > 0) {
                phoneNumber = phoneNumbers[0]["phoneNumber"]
            }
            this.setState({
                form: <CompanyDetailsEditForm
                    companyAddressId={result.attributes.organization.attributes.address.addressId}
                    companyName={result.attributes.organization.attributes.name}
                    companyStreet={result.attributes.organization.attributes.address.street}
                    companyStreet2={result.attributes.organization.attributes.address.street2}
                    companyCity={result.attributes.organization.attributes.address.city}
                    companyState={result.attributes.organization.attributes.address.state}
                    companyStateCode={result.attributes.organization.attributes.address.stateCode}
                    companyCountry={result.attributes.organization.attributes.address.country}
                    companyCountryCode={result.attributes.organization.attributes.address.countryCode}
                    companyPostalCode={result.attributes.organization.attributes.address.postalCode}
                    companyPhoneNumber={phoneNumber}
                    companyEmail={result.attributes.organization.attributes.email}
                    companyDescriptionId={result.id}
                    companyLogoImageId={result.attributes.companyLogoImageId}
                    companyLogo={result.attributes.companyLogo}
                />,
            });
        });
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-12 ui-title-bar">
                        <div className="row">
                            <div className="col-12">
                                <h2>
                                    <FormattedMessage
                                        id="companyDescription.form.edit.title"
                                        defaultMessage="Edit Details"
                                    />
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.form}

            </div>
        );
    }
}

export default CompanyDetailsEdit


// WEBPACK FOOTER //
// ./src/settings/companyDetails/companyDetailsEdit.component.jsx